
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-info",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.15 32 0 24.85 0 16S7.15 0 16 0s16 7.15 16 16-7.15 16-16 16zm0-2.65c7.35 0 13.35-5.95 13.35-13.35S23.35 2.65 16 2.65 2.65 8.65 2.65 16s6 13.35 13.35 13.35zm0-14.7c.75 0 1.35.6 1.35 1.35v6.65c0 .75-.6 1.35-1.35 1.35s-1.35-.6-1.35-1.35V16c0-.75.6-1.35 1.35-1.35zm0-5.3c.75 0 1.35.6 1.35 1.35s-.6 1.35-1.35 1.35-1.35-.6-1.35-1.35c0-.75.6-1.35 1.35-1.35z"}})])
          )
        }
      }
    